import React from "react";

const BULLET = /^\s*(?:[-*•]|\d+[.)])\s+(.*)$/;

const renderInline = (text, keyPrefix) =>
  String(text)
    .split(/(\*\*[^*]+\*\*)/g)
    .filter((part) => part !== "")
    .map((part, i) =>
      part.startsWith("**") && part.endsWith("**") && part.length > 4 ? (
        <strong key={`${keyPrefix}-${i}`} style={{ fontWeight: 600, color: "var(--fc-text-primary)" }}>
          {part.slice(2, -2)}
        </strong>
      ) : (
        <React.Fragment key={`${keyPrefix}-${i}`}>{part}</React.Fragment>
      ),
    );

const toBlocks = (text) => {
  const blocks = [];
  let paragraph = [];
  let list = null;

  const flushParagraph = () => {
    if (paragraph.length) {
      blocks.push({ kind: "p", text: paragraph.join(" ") });
      paragraph = [];
    }
  };
  const flushList = () => {
    if (list) {
      blocks.push({ kind: "ul", items: list });
      list = null;
    }
  };

  String(text || "")
    .replace(/\r/g, "")
    .split("\n")
    .forEach((rawLine) => {
      const line = rawLine.trim();
      if (!line) {
        flushParagraph();
        flushList();
        return;
      }
      const bullet = BULLET.exec(rawLine);
      if (bullet) {
        flushParagraph();
        list = list || [];
        list.push(bullet[1].trim());
        return;
      }
      const heading = /^\*\*([^*]+)\*\*:?$/.exec(line) || /^#{1,4}\s+(.*)$/.exec(line);
      if (heading) {
        flushParagraph();
        flushList();
        blocks.push({ kind: "h", text: heading[1].trim() });
        return;
      }
      flushList();
      paragraph.push(line);
    });

  flushParagraph();
  flushList();
  return blocks;
};

const FormattedText = ({ text }) => {
  const blocks = toBlocks(text);
  const hasMore = blocks.length > 1;

  return (
    <div style={{ fontSize: "13.5px", lineHeight: 1.65, color: "var(--fc-text-secondary)" }}>
      {blocks.map((block, i) => {
        if (block.kind === "h") {
          return (
            <div
              key={i}
              style={{
                fontSize: "11.5px",
                fontWeight: 600,
                letterSpacing: "0.04em",
                textTransform: "uppercase",
                color: "var(--fc-text-muted)",
                margin: i === 0 ? "0 0 6px" : "16px 0 6px",
              }}
            >
              {renderInline(block.text, `h${i}`)}
            </div>
          );
        }
        if (block.kind === "ul") {
          return (
            <ul key={i} style={{ margin: "4px 0 10px", paddingLeft: "20px", listStyle: "disc" }}>
              {block.items.map((item, j) => (
                <li key={j} style={{ margin: "5px 0", paddingLeft: "2px" }}>
                  {renderInline(item, `l${i}-${j}`)}
                </li>
              ))}
            </ul>
          );
        }
        const isLead = i === 0 && hasMore;
        return (
          <p
            key={i}
            style={{
              margin: isLead ? "0 0 12px" : "0 0 10px",
              fontSize: isLead ? "14.5px" : undefined,
              fontWeight: isLead ? 600 : undefined,
              color: isLead ? "var(--fc-text-primary)" : undefined,
            }}
          >
            {renderInline(block.text, `p${i}`)}
          </p>
        );
      })}
    </div>
  );
};

export default FormattedText;
